<template>
  <section class="container">
    <el-form label-width="100px">
      <el-form-item label="描述">
        <quill-editor
          v-model="html"
          @change="handlerTextPage"/>
      </el-form-item>
      <el-form-item label="英文描述">
        <quill-editor
          v-model="englishContent"
          @change="handlerTextPage"/>
      </el-form-item>
    </el-form>
    <!-- <quill-editor
      v-model="html"
      @change="handlerTextPage"/> -->
    <el-button
      class="btn-save"
      type="primary"
      @click="onSave">保存</el-button>
  </section>
</template>

<script>
import QuillEditor from '@/components/quill-editor';
import Mixins from '@/mixins/operations'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  cooperationEdit, cooperation,
} from '@/api/about'

export default {
  data() {
    return {
      html: '<p>测试</p>',
      uuid: '',
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      englishContent: '',
      qiniuDomain: '',
    };
  },
  mixins: [Mixins],
  components: {
    QuillEditor,
  },
  created() {
    this.network().getQiniuInfo()
    this.network().cooperation()
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    html(nv, ov) {
      console.log('====================================');
      console.log(nv);
      console.log('====================================');
    },
  },
  methods: {
    handlerTextPage(data) {
      console.log('====================================');
      console.log(data);
      console.log('====================================');
    },
    onSave() {
      this.network().cooperationEdit()
    },
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    uploadSuccess(res) {
      // this.aboutUs.img = res.hash
      this.network().cooperationEdit(res.hash)
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        cooperation: async () => {
          const { status, data } = await cooperation()
          if (status === 200) {
            this.html = data.char[0].content
            this.englishContent = data.char[0].english_content
            this.uuid = data.char[0].uuid
          }
        },
        cooperationEdit: async () => {
          const { status } = await cooperationEdit({
            uuid: this.uuid,
            content: this.html,
            english_content: this.englishContent,
          })
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
  .about-img {
    max-width: 500px;
  }
  .btn-save {
      margin: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/about/cooperation.vue